import { Injectable } from '@angular/core';
import { NativeAudio } from '@ionic-native/native-audio';
import { ToastController, Platform } from 'ionic-angular';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Media, MediaObject } from '@ionic-native/media';


@Injectable()
export class AudioSystemProvider {

    ASSET_FINISHED: string = "assets/sounds/win.mp3";
    ASSET_PACE: string = "assets/sounds/pace_km.mp3";
    PRELOAD: string = "";
    MESSAGE: string = "";
    ACTIVE_ASSET: string = "";

    LOADED: boolean = false;
    private media: MediaObject;

    constructor(private nativeAudio: NativeAudio,
        private toastController: ToastController,
        private platform: Platform,
        private localNotification: LocalNotifications,
        private mediaService: Media,
        private translate: TranslateService) {
    }

    // preloadSound(): Promise<any> {
    //     return new Promise<any>((resolve, reject) => {
    //         if (!this.LOADED) {
    //             Promise.all([this.nativeAudio.preloadSimple("finished", this.ASSET_FINISHED), this.nativeAudio.preloadSimple("pace", this.ASSET_PACE)]).then(() => {
    //                 this.LOADED = true;
    //                 resolve(null);
    //             });
    //         } else {
    //             resolve(null);
    //         }
    //     });
    // }

    playAudio(background: boolean, finished: boolean, applause: boolean) {
        if (applause) this.play(background, finished);
    }

    play(background: boolean, finished: boolean) {
        this.ACTIVE_ASSET = (finished) ? this.ASSET_FINISHED : this.ASSET_PACE;
        this.MESSAGE = (finished) ? this.translate.instant('RACE_FINISHED') : "";
        this.PRELOAD = (finished) ? "finished" : "pace";

        // if (background) {
        //     if (this.platform.is('android')) {
        //         this.playForeground();
        //     } else {
        this.playMediaAudio();
        //     }
        // } else {
        //     this.playForeground();
        // }
    }

    private playForeground() {
        this.nativeAudio.play(this.PRELOAD).then((data) => {
            console.log('play.then(), data: ' + data);
        }).catch((err) => {
            console.log('foreground play error: ' + err);
        })

        this.toastController.create({
            message: this.MESSAGE,
            duration: 3000,
            position: "top"
        }).present();
    }

    // Play audio
    //
    private playMediaAudio() {
        console.log('this.ACTIVE_ASSET', this.ACTIVE_ASSET)
        // Play the audio file at url
        let audioFile
        if(this.platform.is('ios')){
            audioFile = "file://" + this.ACTIVE_ASSET;
        }else if(this.platform.is('android')){
            audioFile = "file:///android_asset/www/"+this.ACTIVE_ASSET
        }
        
        // Create a new media instance
        this.media = this.mediaService.create(audioFile);

        // Play the audio in the background
        if(this.platform.is('ios')){
            this.media.play({playAudioWhenScreenIsLocked:true}); 
            this.media.setVolume(1);
        }else if(this.platform.is('android')){
            console.log('platf android')
            this.media.play();
            this.media.setVolume(1);
            this.media.onSuccess.subscribe(() => console.log('Audio played successfully'));
            this.media.onError.subscribe(error => console.error('Error playing audio:', error));
        }
    }

    //used for background purposes
    private playNotification() {
        this.platform.ready()
            .then(() => {
                this.localNotification.schedule({
                    id: 1,
                    text: this.MESSAGE,
                    sound: "file://" + this.ACTIVE_ASSET,
                    data: { secret: 'hello' }
                });
            }).catch(err => console.error(err));
    }


}



// WEBPACK FOOTER //
// /src/providers/audio-system/audio-system.ts